import { Modal as AntModal } from "antd"
import type { RefObject } from "react"
import style from "./QuotationViewerModal.module.scss"

const { editorContainer, host } = style

type Props = {
	open: boolean
	onClose: () => void
	// Slot for the single shared Apryse host (owned by QuotationViewerModal). The host is moved
	// into this div imperatively, so the editor needs no Splitter / side panels — just a bare,
	// fullscreen host with no resize bars or margins. #1119
	slotRef: RefObject<HTMLDivElement>
}

export const QuotationEditorModal = ({ open, onClose, slotRef }: Props) => {
	return (
		<AntModal
			open={open}
			onCancel={onClose}
			footer={null}
			closable={false}
			// Escape must NOT close the whole editor — it only closes the right sidebar, handled by
			// the hotkey layer (useEditorHotkeys). rc-dialog's own Escape listener sits below window
			// in the bubble path, so it would fire first and close the editor before the hotkey layer
			// could scope it; disabling it here leaves the hotkey layer as the sole owner of Escape.
			keyboard={false}
			width="100%"
			centered={false}
			styles={{
				// borderRadius: 0 keeps the editor truly fullscreen — no rounded corners, no padding.
				content: { padding: 0, borderRadius: 0, height: "100vh" },
				body: { height: "100vh", padding: 0, display: "flex", flexDirection: "column" },
			}}
			style={{ top: 0, maxWidth: "100%", padding: 0, margin: 0 }}
		>
			<div className={editorContainer}>
				<div ref={slotRef} className={host} />
			</div>
		</AntModal>
	)
}
